import React, { useState, useEffect } from 'react';
import { I18n } from 'react-redux-i18n';

function DigitalClock({
  onCheckboxChange,
  refreshTime = '',
  showAutoRefresh = true,
}) {
  const [time, setTime] = useState(new Date());
  const [isChecked, setIsChecked] = useState(true);
  const [intervalId, setIntervalId] = useState(null);

  const clockStyle = {
    fontSize: '48px',
    fontWeight: 'bold',
    fontFamily: 'monospace',
  };

  useEffect(() => {
    const timerId = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timerId);
  }, []);

  useEffect(() => {
    if (!showAutoRefresh || !isChecked) {
      if (intervalId) {
        clearInterval(intervalId);
        setIntervalId(null);
      }
      return undefined;
    }

    if (!intervalId) {
      const interval = refreshTime ? refreshTime * 1000 : 300000;
      const id = setInterval(() => {
        onCheckboxChange();
      }, interval);

      setIntervalId(id);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isChecked, intervalId, onCheckboxChange, refreshTime, showAutoRefresh]);

  // Formata o tempo em HH:MM:SS
  const formatTime = (date) => date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false, // Define o formato 24 horas
  });

  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setIsChecked(checked);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <h2>{I18n.t('BEE4188' /* Horário atual */).toUpperCase()}</h2>
      <div style={clockStyle}>{formatTime(time)}</div>
      {showAutoRefresh && (
      <div style={{ marginTop: '5px' }}>
        {/*  eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <input
            type="checkbox"
            style={{ marginRight: '8px' }}
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          {refreshTime
            ? I18n.t('BEE4354', { 0: refreshTime } /*  Atualizar os dados a cada %{0} segundos. */)
            : I18n.t('BEE4189' /* Atualizar os dados a cada 5 minutos */)}
        </label>
      </div>
      )}
    </div>
  );
}

export default DigitalClock;
